import { Navigate } from "react-router-dom";
import useStore from "../store/store";
import routes from "../constants/routes";

const PublicRoute = ({ outlet: Outlet }) => {
  const user = useStore((state) => state.user);

  if (user) return <Navigate to={routes.adminProducts.list.path} />;
  return <Outlet />;
};

export default PublicRoute;
